import React, { useMemo, useState } from "react";
import { HiDotsVertical } from "react-icons/hi";
import PageName from "../../components/PageName";
import Card from "../../components/Base/Card";
import {FiChevronDown, FiPlus, FiX} from "react-icons/fi";
import BaseFilter from "../../components/Base/BaseFilter";
import BaseDateRangePicker from "../../components/Base/BaseDateRangePicker";
import { Table } from "../../components/Base/BaseTable";
import { useForm } from "react-hook-form";
import SuccessModal from "../../components/SuccessModal";
import { sendFeedback } from "../../redux/feedback/feedbackSlice";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import LoadingSpinner from "../../components/LoadingSpinner";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import ErrorViewer from "../../components/ErrorViewer";
import Required from "../../components/Required";

const Feedback = () => {
  const [filterValue, setFilterValue] = useState("");
  const [startDate, setStartDate] = useState<Date>();
  const [endDate, setEndDate] = useState<Date>();
  const [showFeedbackForm, setShowFeedbackForm] = useState(true);
  const [showFeedbackSuccess, setShowFeedbackSuccess] = useState(false);
  const dispatch = useAppDispatch();
  const { isLoading } = useAppSelector((state) => state?.feedback);

  const toggleShowFeedbackForm = () => setShowFeedbackForm(!showFeedbackForm);

  const toggleShowFeedbackSuccess = () =>
    setShowFeedbackSuccess(!showFeedbackSuccess);

  const resetAll = () => {
      reset()
    toggleShowFeedbackSuccess();
  };

    const validationSchema = Yup.object().shape({
        subject: Yup.string().required("Subject is required"),
        body: Yup.string().required("Message is required"),
        header: Yup.string().required("Please select request type"),
    });

  const setDateRangeHandler = (dates: Date[]) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
  };

    const {
        handleSubmit, reset, register,
        formState: {errors},
    } = useForm({
        resolver: yupResolver(validationSchema),
        defaultValues: {
            subject: "",
            body: "",
            header: "",
        },
    });

  const onSubmit = async (values: any, e: any) => {
    e.preventDefault();
    const feedbackResp = await dispatch(sendFeedback({
        ...values,
        // files: uploadedFiles
    }));
    if (feedbackResp.type === "feedback/fulfilled" && feedbackResp.payload?.statusCode === "00") {
        reset();
      toggleShowFeedbackSuccess();
    }
  };

  const columns: any = useMemo(
    () => [
      {
        Header: "#",
        accessor: "id",
      },
      {
        Header: "First Name",
        accessor: "firstName",
      },
      {
        Header: "Last Name",
        accessor: "lastName",
      },
      {
        Header: "Subject",
        accessor: "subject",
      },
      {
        Header: "Feedback Type",
        accessor: "feedbackType",
      },
      {
        Header: "Message",
        accessor: "message",
      },
      {
        Header: "Date Created",
        accessor: "dateCreated",
      },
      {
        Header: "Status",
        accessor: "status",
        // @ts-ignore
        Cell: ({ cell: { value } }) => (
          <div
            className={`py-1 font-medium  w-[120px] text-center rounded-full ${
              value
                ? "bg-grayscaleLine text-blue700"
                : "text-danger bg-bangerBG"
            }`}
          >
            In Progress
          </div>
        ),
      },
      {
        Header: "Action",
        accessor: "",
        // @ts-ignore
        Cell: ({ row: { values } }) => {
          return (
            <button className="btn btn-text" onClick={() => {}}>
              <HiDotsVertical />
            </button>
          );
        },
      },
    ],
    []
  );

  const tableData: any = useMemo(
    () => [
      {
        id: 1,
        firstName: "Oluwasegun",
        lastName: "Segun",
        subject: "Can't access my account",
        feedbackType: "request",
        message: "Stanbic IBTC Pension Managers Limited",
        dateCreated: "04/01/2023 02:25:21",
        status: "In Progress",
      },
    ],
    []
  );

  return (
    <div className="transaction-page">
      <PageName pageName={"Feedback"} />
      {!showFeedbackForm ? (
        <div className="transaction">
          <Card className="transaction-card">
            <div className="h1 text-grayscaleBody border-b pb-4">
              Feedback Management
            </div>
            <div className="flex justify-end mt-10">
              <button
                className="btn btn-primary btn-b"
                onClick={toggleShowFeedbackForm}
              >
                <FiPlus className="text-xl mr-4" />
                New Feedback
              </button>
            </div>
            <div className="table-filter-group">
              <div className="table-filter">
                <BaseFilter
                  value={filterValue}
                  onChange={(val) => setFilterValue(val)}
                />
                <BaseDateRangePicker
                  className="mt-4 sm:mt-0 max-w-full  sm:max-w-[328px] sm:ml-4"
                  onChange={(date) => setDateRangeHandler(date)}
                />
                {/*
                <div>
                  <button className="btn btn-outline btn-b">Search</button>
                </div>
                */}
              </div>
              <div className="table-sort">
                <button className="btn btn-outline btn-b">
                  Sort
                  <FiChevronDown className="ml-2 " />
                </button>
              </div>
            </div>
            <div className="mt-10">
              {/*@ts-ignore*/}
              <Table
                filterValue={filterValue}
                columns={columns}
                data={tableData}
              />
            </div>
          </Card>
        </div>
      ) : (
        <div className="transaction">
          <SuccessModal
            showModal={showFeedbackSuccess}
            onClose={resetAll}
            note={"Your feedback has been submitted successfully."}
          />
          <Card className="transaction-card">
            <div className="h1 text-grayscaleBody">Add Feedback</div>
            <Card>
              <div className="section-card">
                <div>Feedback Information</div>
                <div className="pb-8">
                  <div className="form w-full">
                    <div className="form__row">
                      <div className="form__group">
                        <label htmlFor="subject" className="form__label">
                          Subject <Required />
                        </label>
                        <input
                          id="subject"
                          placeholder="Enter Subject"
                          type="text"
                          className="form__input"
                          disabled={isLoading}
                          {...register("subject")}
                        />
                          {errors.subject && (
                              <ErrorViewer message={errors.subject.message as string} />
                          )}
                      </div>
                      <div className="form__group">
                        <label htmlFor="feedback-type" className="form__label">
                          Feedback Type <Required />
                        </label>
                        <select
                          id="feedback-type"
                          className="form__input"
                          defaultValue=""
                          {...register("header")}
                        >
                          <option value="" disabled>
                            Select feedback type
                          </option>
                          <option value="request">Request</option>
                          <option value="complain">Complain</option>
                          {/*<option value="whistleblowing">Whistleblowing</option>*/}
                        </select>
                          {errors.header && (
                              <ErrorViewer message={errors.header.message as string} />
                          )}
                      </div>
                    </div>
                    <div className="form__group">
                      <label htmlFor="message" className="form__label">
                        Message <Required />
                      </label>
                      <textarea
                        id="message"
                        rows={5}
                        className="form__input"
                        disabled={isLoading}
                        {...register("body")}
                      />
                        {errors.body && (
                            <ErrorViewer message={errors.body.message as string} />
                        )}
                    </div>
                    {/*
                    <div className="form__group">

                          <label htmlFor="lastName" className="form__label">
                              Attachment
                          </label>
                          <Dropzone onDrop={addFilesForUpload} accept={"image/jpeg,image/gif,image/png,application/pdf"} />
                          <ul className="my-3">
                              {
                                  uploadedFiles && uploadedFiles.map((file, index)=>(
                                      <li className="flex items-center" key={index}>
                                          <div>{file.name}</div>
                                          <button className="btn btn-icon ml-4" onClick={()=>removeFile(file)}>
                                              <FiX />
                                          </button>
                                      </li>
                                  ))
                              }
                          </ul>
                      </div>
                    */}
                  <div className="flex justify-end">
                      <button className="btn btn-outline mr-4">Reset</button>
                      <button
                        className="btn btn-primary"
                        onClick={handleSubmit(onSubmit)}
                        disabled={isLoading}
                      >
                        {isLoading ? <LoadingSpinner /> : "Submit"}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </Card>
          </Card>
        </div>
      )}
    </div>
  );
};
export default Feedback;
